/**
 * Cloud provider detection utility
 *
 * Determines the active cloud provider from the Vite environment mode.
 * Mode format: [env]-[cloud]-[tenant]  e.g. "prod-aws-wbai", "prod-az-wbai"
 *
 * Also supports the VITE_CLOUD_PROVIDER env var as an explicit override
 * (set in CI pipelines, e.g. frontend-azure.yml sets VITE_CLOUD_PROVIDER=azure).
 */

export type CloudProvider = "azure" | "aws" | "unknown";

export function detectCloudProvider(): CloudProvider {
  // Explicit env var override takes precedence
  const explicit = import.meta.env.VITE_CLOUD_PROVIDER as string | undefined;

  if (explicit === "azure" || explicit === "az") return "azure";
  if (explicit === "aws") return "aws";

  // Parse from MODE: "prod-az-wbai" -> cloud = "az"
  const mode = import.meta.env.MODE ?? "";
  const parts = mode.split("-");

  if (parts.length >= 2) {
    const cloud = parts[1];

    if (cloud === "az") return "azure";
    if (cloud === "aws") return "aws";
  }

  // Fallback: if App Insights connection string is present, assume Azure
  if (import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING) return "azure";

  return "unknown";
}
